import _ from 'lodash';
import { createActionFactory } from '../../common/redux';

const { createAction } = createActionFactory('Experience workspace => smart urls => ');

const removeSmartUrl = createAction('remove smart url', id => ({ id }));

const add = createAction(
  'add smart urls',
  smartUrls => (_.isArray(smartUrls) ? { smartUrls } : { smartUrls: [smartUrls] })
);
const fetchSmartUrlsSuccess = createAction('fetch smart url success', smartUrls => ({ smartUrls }));

export default { removeSmartUrl, add, fetchSmartUrlsSuccess };
